/**
 * シフト枠ステータス
 */
export type ShiftSlotStatus =
  | 'draft'       // 下書き
  | 'recruiting'  // 募集中
  | 'closed'      // 締切
  | 'confirmed';  // 確定

/**
 * ステータス表示ラベル
 */
export const SHIFT_SLOT_STATUS_LABELS: Record<ShiftSlotStatus, string> = {
  draft: '設定中',
  recruiting: '募集中',
  closed: '締切',
  confirmed: '確定',
};
